module.exports = __webpack_public_path__ + "img/ingresos.832e8ce2.svg";